import { Dispatch } from 'redux'

import * as Api from 'redux/api/VariantOptions'
import { useThunkActions } from 'redux/actions/useThunkActions'

import {
  ComparativeDisplayType,
  RollingType
} from 'types/GlobalKpiOption'
import { ShowPerEnum } from 'types/GlobalMetric'

import * as actions from './actions'

export function tryCreateVariantOptionBy(body: {
  widget_id: string
  variant_kpi_template_id: string
  title: string
}) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    Api.create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.createFailed())
      })
  }
}

export function tryUpdateVariantOptionBy(
  id: string,
  body: {
    active_show_per?: ShowPerEnum | null
    title?: string
    number_of_decimals?: number
    rolling_active?: RollingType | null
    comparative_display_type?: ComparativeDisplayType
  }
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    Api.update(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.updateFailed())
      })
  }
}

export function tryDeleteVariantOptionBy(id: string, widgetId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    Api.destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess({ id, widgetId }))
      })
      .catch(() => {
        dispatch(actions.destroyFailed())
      })
  }
}

export const useVariantOptionActions = () => {
  return {
    tryCreateVariantOptionBy: useThunkActions(tryCreateVariantOptionBy),
    tryUpdateVariantOptionBy: useThunkActions(tryUpdateVariantOptionBy),
    tryDeleteVariantOptionBy: useThunkActions(tryDeleteVariantOptionBy)
  }
}
